define('modules/form_editor/views/editor_advanced_common',['require','exports','module','base/view','../../editor/models/editorstate','lib/util','ldsh!../templates/editor_advanced_common'],function(require, exports, module) {
  "use strict";
  var BaseView = require("base/view"),
    EditorState = require("../../editor/models/editorstate"),
    util = require("lib/util");

  module.exports = BaseView.extend({
    template: require("ldsh!../templates/editor_advanced_common"),

    events: {
      "change .js-error-message": "updateModel",
      "change .js-social-binding": "updateModel",
      "change .js-name-attr": "updateModel",
      "click .js-toggle-advanced-mode": "toggleAdvancedMode",
      "click .js-help": "triggerTooltip",
      "change .server-validation-trigger-selector": "toggleServerValidationTriggers",
      "change .js-server-validation": "updateModel"
    },

    initialize: function () {
      if (this.model.get("isServerValidation")) {
        this.options.vent.trigger("form:showAdvancedMode", true);
      }
    },

    helpers: function() {
      var templateParams = {
        isPopup: EditorState.isCurrentStepPopup(),
        errorMessage: this.model.get('errorMessage') || '',
        showSocialBind: this.model.isSocialBindable && this.model.isInSocialForm(),
        isRadioGroup: this.model.get('name') === 'input:radiogroup',
        isHiddenField: this.model.get('name') === 'input:hidden',
        isAdvancedMode: this.options.options.model.get('isAdvancedMode'),
        isServerValidation: this.model.get('isServerValidation') || false,
        validationInServer: this.getValidationInServer(),
        serverValidationURL: this.model.get('serverValidationURL'),
        serverValidationMethod: this.model.get('serverValidationMethod') || 'get',
        serverValidationErrorMessage: this.model.get('serverValidationErrorMessage'),
        serverValidationResponseType: this.model.get('serverValidationResponseType') ||'JSON',
        serverValidationResponseJSON: this.model.get('serverValidationResponseJSON'),
        serverValidationResponseJSONCriteria: this.model.get('serverValidationResponseJSONCriteria') || 'ok',
        serverValidationResponseCode: this.model.get('serverValidationResponseCode'),
        serverValidationResponseCodeCriteria: this.model.get('serverValidationResponseCodeCriteria') || 'ok'
      };

      return templateParams;
    },

    triggerTooltip: function() {
      this.$(".js-tooltip").toggleClass("in");
    },

    getValidationInServer: function() {
      var isAMP = EditorState.getAMPState(),
        elements = ["input:text", "custom:telephone", "custom:email", "custom:iban", "custom:password", "custom:date"],
        currentElement = this.model.get("name");

      return isAMP ? elements.includes(currentElement) : false;
    },

    onRender: function() {
      this.$el.i18n();
      this.$(".js-social-binding").val(this.model.get("socialBinding") || "");
      var list = this.model.getModifiedIntegrations();
      if (list) this.displayIntegrationsWarning(list);
    },

    toggleServerValidationTriggers: function (e) {
      this.$('.server-validation-configuration').toggle($(e.currentTarget).is(':checked'));
      this.$('.js-server-validation').val('');

      $('.server-validation-radio-group').each(
        function() {
          $(this).find('[type="radio"]:checked').removeAttr('checked').end()
            .find('[type="radio"]:first').attr('checked', 'checked');
        });

      this.updateModel();
    },

    updateModel: function() {
      var domAttrs = {
          errorMessage: ".js-error-message",
          socialBinding: ".js-social-binding",
          nameAttr: ".js-name-attr",
          isServerValidation: '.server-validation-trigger-selector',
          serverValidationMethod: '.server-validation-method:checked',
          serverValidationURL: ".js-server-validation",
          serverValidationErrorMessage: ".js-server-validation-error",
          serverValidationResponseType: '[name="serverValidationResponseType"]:checked',
          serverValidationResponseJSON: '[name="serverValidationResponseJSON"]',
          serverValidationResponseJSONCriteria: '[name="serverValidationResponseJSONCriteria"]:checked',
          serverValidationResponseCode: '[name="serverValidationResponseCode"]',
          serverValidationResponseCodeCriteria: '[name="serverValidationResponseCodeCriteria"]:checked',
        },
        modelAttrs = _.reduce(domAttrs, function (modelAttrs, el, attr) {
          var $ele = this.$(el),
            value = $ele.val();

          if ($ele.is(':checkbox')) {
            modelAttrs[attr] = $ele.is(':checked');

            return modelAttrs;
          }

          if (value) {
            if (attr === 'nameAttr') {
              modelAttrs[attr] = util.sanitizeString(value);
              $ele.val(modelAttrs[attr]);
            } else {
              modelAttrs[attr] = value.trim();
            }
          }

          return modelAttrs;
        }, {}, this);

      this.stopListening(this.model, "change");
      this.model.set(modelAttrs);
      this.listenTo(this.model, "change", this.render);
      this.model.trigger("change");
    },

    toggleAdvancedMode: function () {
      this.options.vent.trigger("form:showAdvancedMode");
      this.render();
    },

    displayIntegrationsWarning: function(list) {
        var help = $.i18n.t("formEditor.nameAttributeHelp") + ": " + list;
        this.$(".js-tooltip-name-msg").text(help);
        this.$(".js-tooltip-name").addClass("in");
    }
  });
});

